<script setup>
import { reactive } from 'vue';
import { processScheduleFile } from '@/firebase_files/document_ai'; // Ensure correct path
import { setScheduleFile, setDate, store } from '@/store';
import { formatDate } from '@/libraries/DateFunctions';


import ClinicDate from './ClinicDate.vue';

const props = defineProps(['initialDate',])
const emits = defineEmits(['dateChange']);

const state = reactive({
  dateString: null,
  date: null,
  isUploading: false,

});

init()

function init() {
  state.date = props.initialDate;
  state.dateString = state.date.toDateString();
}

function onFileChange(event) {
  state.isUploading = true;
  store.aptDone = false; // aptDone is global and triggers 
  setDate(formatDate(state.date));
  const file = event.target.files[0];
  if (file) {
    setScheduleFile(file);
    processScheduleFile();
  }
}

async function onDateChange(date) {
  state.date = date;
  state.dateString = date.toDateString();
  emits('dateChange', date);
}

</script>

<template>
  <div class="container">
    <div v-if="!state.isUploading">
      <ClinicDate :text="'Change date:'" :initial-date="state.date" @set-date="(d) => onDateChange(d)" />
      <h2>We have no record for a clinic schedule for {{ state.dateString }}</h2>
      <h3>Would you like to upload one now?</h3>
      <input type="file" @change="onFileChange($event)">
    </div>

    <div v-else class="upload">
      <div class="spinner">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
      <h2>Clinic Uploading...</h2>
      <p class="warning">This may take a few seconds, please do not refresh your page</p>
    </div>
  </div>
</template>
<style scoped lang="scss">
h2,
h3 {
  display: block;
}
.upload{
  margin-top: 15rem;
  h2{
    margin: 3rem;
  }

}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

div.spinner {
  font-size: 30px;
  text-align: center;
  color: #aaa;
  padding-top: 20px;
}

p {
  font-family: 'Roboto', sans-serif;
  color: #000;

  .warning {
    font-size: 20px;

    padding-top: 20px;
  }
}
</style>